import { render, staticRenderFns } from "./agregarSeccion.vue?vue&type=template&id=60b72d44&"
import script from "./agregarSeccion.vue?vue&type=script&lang=js&"
export * from "./agregarSeccion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports